import { useState } from 'react';
import { portfolioData } from '../../../mocks/portfolio';

export default function Skills() {
  const { skills } = portfolioData;
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(0);

  return (
    <section className="bg-[#f5f1ed] py-32">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <div className="text-center mb-20">
          <h2 className="text-[#2a2a2a] text-5xl lg:text-6xl font-bold mb-4">
            専門スキルと得意分野 ✨
          </h2>
          <p className="text-[#666666] text-xl max-w-3xl mx-auto leading-relaxed">
            多様なデザイン領域において、理論と実践の両面から深い知識と経験を積み重ねてきました。
            それぞれのスキルを組み合わせることで、包括的なデザインソリューションを提供します。
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skills.map((skill, index) => (
            <div
              key={index}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                hoveredIndex === index ? 'scale-105 shadow-2xl' : 'scale-100'
              }`}
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Background Image */}
              <img 
                src={skill.image}
                alt={skill.title}
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-white text-3xl font-bold mb-3">{skill.title}</h3>
                <p className={`text-white text-base leading-relaxed mb-4 transition-all duration-300 ${
                  hoveredIndex === index ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0 overflow-hidden'
                }`}>
                  {skill.description}
                </p>

                {/* Level Indicator */}
                <div className="flex gap-2">
                  {[...Array(5)].map((_, i) => (
                    <div
                      key={i}
                      className={`w-3 h-3 rounded-full ${
                        i < skill.level ? 'bg-[#d4c5b9]' : 'bg-white/30'
                      }`}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}